import React, { useEffect, useRef } from 'react';
import './PrivacyModal.css'; /* reutiliza os mesmos estilos */

function TermsModal({ onClose }) {
  const closeRef = useRef(null);

  useEffect(() => {
    closeRef.current?.focus();
    function handleKey(e) {
      if (e.key === 'Escape') onClose();
    }
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [onClose]);

  return (
    <div className="legal-backdrop" onClick={onClose} role="presentation">
      <div
        className="legal-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="terms-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="legal-header">
          <h2 className="legal-title" id="terms-title">Termos de Uso</h2>
          <button
            ref={closeRef}
            className="legal-close"
            onClick={onClose}
            aria-label="Fechar termos de uso"
          >
            ✕
          </button>
        </div>

        <div className="legal-body">
          <p className="legal-updated">Última atualização: abril de 2025</p>

          <h3>1. Objeto</h3>
          <p>
            O <strong>Painel Saneamento Vivo</strong> é uma plataforma de visualização e análise de
            dados geoespaciais relacionados ao saneamento básico. O acesso à plataforma implica a
            aceitação integral destes Termos de Uso.
          </p>

          <h3>2. Acesso e cadastro</h3>
          <p>
            O acesso à plataforma é restrito a usuários autorizados. As contas são criadas
            exclusivamente pelos administradores do sistema, mediante solicitação formal e validação
            institucional. Não há cadastro autônomo por parte do usuário.
          </p>
          <p>
            O usuário é responsável pela confidencialidade de suas credenciais de acesso e deve
            comunicar imediatamente ao administrador qualquer uso não autorizado de sua conta.
          </p>

          <h3>3. Uso adequado</h3>
          <p>É expressamente proibido:</p>
          <ul>
            <li>Utilizar a plataforma para fins ilegais ou contrários à legislação brasileira</li>
            <li>Realizar coleta automatizada de dados (<em>scraping</em>) sem autorização prévia</li>
            <li>Sobrecarregar intencionalmente os servidores da plataforma</li>
            <li>Tentar acessar dados ou funcionalidades para os quais seu perfil não possui autorização</li>
            <li>Compartilhar credenciais de acesso com terceiros</li>
          </ul>

          <h3>4. Propriedade intelectual e fontes de dados</h3>
          <p>
            Os dados geoespaciais disponibilizados nesta plataforma são provenientes de fontes públicas
            (IBGE, concessionárias de saneamento, órgãos governamentais) e de dados fornecidos por
            parceiros institucionais. A plataforma e seus componentes originais são protegidos por
            direitos de propriedade intelectual de seus respectivos titulares.
          </p>

          <h3>5. Limitação de responsabilidade</h3>
          <p>
            Os dados disponibilizados têm caráter informativo e não substituem documentação oficial,
            laudos técnicos ou pareceres legais. A plataforma não se responsabiliza por decisões
            tomadas com base exclusiva nas informações aqui apresentadas.
          </p>
          <p>
            A disponibilidade contínua do serviço não é garantida, podendo ocorrer interrupções para
            manutenção, atualizações ou por motivos de força maior.
          </p>

          <h3>6. Suspensão e cancelamento de acesso</h3>
          <p>
            O acesso pode ser suspenso ou cancelado a qualquer momento em caso de violação destes
            Termos de Uso ou por decisão administrativa do moderador responsável.
          </p>

          <h3>7. Alterações nos Termos</h3>
          <p>
            Estes Termos de Uso podem ser alterados a qualquer momento. Alterações relevantes serão
            comunicadas com antecedência mínima de <strong>15 dias corridos</strong> por e-mail
            cadastrado. O uso continuado da plataforma após esse prazo implica a aceitação das
            alterações.
          </p>

          <h3>8. Foro</h3>
          <p>
            Fica eleito o foro da comarca de Brasília/DF para dirimir quaisquer controvérsias
            decorrentes destes Termos de Uso, com renúncia expressa a qualquer outro, por mais
            privilegiado que seja.
          </p>
        </div>

        <div className="legal-footer">
          <button className="legal-btn-close" onClick={onClose}>
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}

export default TermsModal;
